import { render, staticRenderFns } from "./OutOfAttempt.vue?vue&type=template&id=7d0ffcf3&scoped=true&"
import script from "./OutOfAttempt.vue?vue&type=script&lang=js&"
export * from "./OutOfAttempt.vue?vue&type=script&lang=js&"
import style0 from "./OutOfAttempt.vue?vue&type=style&index=0&id=7d0ffcf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ffcf3",
  null
  
)

export default component.exports